import React from 'react'

function UserAgreementsPage() {
  return (
    <div>UserAgreementsPage</div>
  )
}

export default UserAgreementsPage;